import React from 'react';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

export function ZoneCard({ title, body, onClick }) {
  return (
    <div
      className="d-flex justify-content-between cursor-pointer"
      style={{ borderBottom: 'solid 1px #AAAAAA' }}
    >
      <div className="flex-column" style={{ width: '90%' }}>
        <div className="col-12 pr-0 my-1 zone-card name">
          <h6 className="font-weight-bolder mb-0">{title}</h6>
        </div>
        <div className="col-12 pr-0 my-1 zone-card description">
          <span className="dark-grey">{body}</span>
        </div>
      </div>
      <div
        className="d-flex align-items-center"
        style={{ width: '10%' }}
        onClick={onClick}
      >
        <SVG src={toAbsoluteUrl('/media/svg/senseworks/view.svg')} />
      </div>
    </div>
  );
}
